module.exports = __webpack_public_path__ + "plane-classic.92db23ad8855ad3e43e9.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/plane-classic.svg
// module id = ../../../../../src/assets/img/plane-classic.svg
// module chunks = main